import { type InferInsertModel, type InferSelectModel, sql } from 'drizzle-orm';
import {
  boolean,
  check,
  doublePrecision,
  integer,
  pgEnum,
  pgTable,
  text,
  timestamp,
  uuid,
} from 'drizzle-orm/pg-core';

import { softDelete } from '../columns/soft-delete';

/** Tipo da operação. Define o rótulo no app (Forja/Kids/Outro); `outro` = evento avulso. */
export const eventKindEnum = pgEnum('event_kind', ['forja', 'kids', 'outro']);

export const events = pgTable(
  'events',
  {
    id: uuid('id')
      .primaryKey()
      .$defaultFn(() => Bun.randomUUIDv7()),
    name: text('name').notNull(),
    city: text('city').notNull(),
    value: doublePrecision('value').notNull(),
    /** Início e fim da operação (UTC, sem fuso). O texto do período sai de `eventPeriod` (event.repository). */
    date: timestamp('date', { mode: 'string' }).notNull(),
    endDate: timestamp('end_date', { mode: 'string' }).notNull(),
    pixCode: text('pix_code'),
    kind: eventKindEnum('kind').notNull().default('forja'),
    /** Vagas da operação — só informativo (barra de preenchimento no app), não bloqueia inscrição. */
    slots: integer('slots'),
    isActive: boolean('is_active').default(true),
    createdAt: timestamp('created_at')
      .notNull()
      .$defaultFn(() => new Date()),
    updatedAt: timestamp('updated_at')
      .$onUpdate(() => new Date())
      .notNull(),
    ...softDelete,
  },
  (table) => [
    check('events_end_date_after_date', sql`${table.endDate} >= ${table.date}`),
  ],
);

export type Event = InferSelectModel<typeof events>;
export type EventKind = (typeof eventKindEnum.enumValues)[number];
export type CreateEventInput = InferInsertModel<typeof events>;
export type UpdateEventInput = Partial<CreateEventInput>;
